import React from "react"
import { IScheduleBudgetUnitsSettings } from "../../models"
import ScheduleBudgetUnits from "./budget_units/ScheduleBudgetUnits"
import ScheduleBudgetUnitPositionDefinitions from "./budget_units/ScheduleBudgetUnitPositionDefinitions"
import _ from "lodash"
interface IProps {
    readonly?: boolean
    isRoot?: boolean
    overridden?: boolean
    settingObj?: IScheduleBudgetUnitsSettings
    handleChangeSettingObj?(settingObj: IScheduleBudgetUnitsSettings): void
}

const HierarchySettingsScheduleBudgetUnits: React.SFC<IProps> = (props: IProps) => {
    const editable = props.isRoot || props.overridden
    const useSettings = props.settingObj && props.settingObj.Use ? true : false
    const readonly = props.readonly || !editable || !useSettings
    const budgetUnits = _.cloneDeep((props.settingObj && props.settingObj.UnitItems) || [])
    const budgetUnitPositionDefinitions = _.cloneDeep((props.settingObj && props.settingObj.BudgetUnitItems) || [])
    return (
        <div>
            <ScheduleBudgetUnits
                readonly={readonly}
                budgetUnits={budgetUnits}
                handleUpdate={items => {
                    const { settingObj } = props
                    settingObj.UnitItems = items
                    props.handleChangeSettingObj(settingObj)
                }}
            />
            <ScheduleBudgetUnitPositionDefinitions
                readonly={readonly}
                budgetUnits={budgetUnits}
                budgetUnitPositionDefinitions={budgetUnitPositionDefinitions}
                handleUpdate={items => {
                    const { settingObj } = props
                    settingObj.BudgetUnitItems = items
                    props.handleChangeSettingObj(settingObj)
                }
                }
            />
        </div>
    )
}

export default HierarchySettingsScheduleBudgetUnits